import React from "react";
import { useNavigate } from "react-router-dom";

import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const MotorCard = ({ motor, onConsult }) => {
  const navigate = useNavigate();

  const formatPrice = (price) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div className="bg-card rounded-xl shadow-card-hover overflow-hidden group hover:shadow-honda-glow transition-all duration-300 flex flex-col h-full">

      {/* IMAGE */}
      <div className="relative overflow-hidden aspect-[4/3] bg-muted">
        <Image
          src={motor?.image}
          alt={motor?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />

        {/* LABEL */}
        {motor?.isNew && (
          <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-heading font-bold shadow-honda-subtle">
            BARU
          </div>
        )}

        {motor?.promo && (
          <div className="absolute top-3 right-3 bg-warning text-warning-foreground px-3 py-1 rounded-full text-xs font-heading font-bold shadow-honda-subtle">
            PROMO
          </div>
        )}

        {/* CC & KM/L */}
        <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
          <div className="bg-card/90 backdrop-blur-sm px-3 py-1.5 rounded-lg flex items-center space-x-2">
            <Icon name="Gauge" size={16} color="var(--color-primary)" />
            <span className="text-xs font-heading font-semibold text-foreground">
              {motor?.engineSize}
            </span>
          </div>

          <div className="bg-card/90 backdrop-blur-sm px-3 py-1.5 rounded-lg flex items-center space-x-2">
            <Icon name="Fuel" size={16} color="var(--color-primary)" />
            <span className="text-xs font-heading font-semibold text-foreground">
              {motor?.fuelEfficiency}
            </span>
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div className="p-4 md:p-5 lg:p-6 flex flex-col flex-1">

        {/* TITLE */}
        <div className="mb-3">
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground mb-1 line-clamp-1">
            {motor?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground font-medium">
            {motor?.category}
          </p>
        </div>

        {/* PRICE */}
        <div className="border-t border-border pt-4 mt-auto">
          <div className="mb-4">
            <p className="text-xs text-muted-foreground mb-1">
              Harga Mulai Dari
            </p>
            <p className="text-xl md:text-2xl font-heading font-bold text-primary">
              {formatPrice(motor?.price)}
            </p>
          </div>

          {/* BUTTON */}
          <div className="grid grid-cols-2 gap-2">
            <Button
              variant="outline"
              size="sm"
              fullWidth
              iconName="Info"
              iconPosition="left"
              onClick={() => navigate(`/produk/motor/${motor.slug}`)}
            >
              Detail
            </Button>

            <Button
              variant="default"
              size="sm"
              fullWidth
              iconName="MessageCircle"
              iconPosition="left"
              onClick={() => onConsult(motor)}
            >
              Konsultasi
            </Button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default MotorCard;
